module.exports = __webpack_public_path__ + "static/media/banner_420x230_10.157237da.jpg";